export default __webpack_public_path__ + "static/media/ai_motionActive.d396750e.svg";